import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from 'components/SVGIcon';
import { ReactComponent as FacebookIcon } from './icon-facebook.svg';
import { ReactComponent as InstagramIcon } from './icon-instagram.svg';
import './index.scss';

/*
 * Types definition
 */
const propTypes = {
    facebookUrl: PropTypes.string,
    instagramUrl: PropTypes.string,
};

const defaultProps = {
    facebookUrl: null,
    instagramUrl: null,
};

/*
 * Component
 */
function SocialMedia({ facebookUrl, instagramUrl }) {
    if (!facebookUrl && !instagramUrl) {
        return null;
    }

    return (
        <div className="social-media">
            {facebookUrl
            && (
                <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
                    <SVGIcon icon={FacebookIcon} />
                </a>
            )}
            {instagramUrl
            && (
                <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
                    <SVGIcon icon={InstagramIcon} />
                </a>
            )}
        </div>
    );
}

SocialMedia.propTypes = propTypes;
SocialMedia.defaultProps = defaultProps;

export default SocialMedia;
